import { Link } from "react-router-dom";
import styled from "styled-components";

export const Header = styled.header`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    margin-bottom: 32px;

    p {
        text-align: center;
        text-wrap: balance
    }
`;

export const IconBox = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border: 1px;
    border-color: #293138;
    border-style: solid;
    border-radius: 12px;
`;

export const Footer = styled.footer`
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-top: 56px;
`;

export const LinkStyled = styled(Link)`
    font-weight: 600;
    color: #1ec88e;
    transition: color 0.15s ease;

    &:hover {
        color: #86f3cf;
    }
`;
